var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUtilities(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 27,
    viewBox: "0 0 25 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 5.45C23 7.35538 18.299 8.9 12.5 8.9C6.70101 8.9 2 7.35538 2 5.45M23 5.45C23 3.54462 18.299 2 12.5 2C6.70101 2 2 3.54462 2 5.45M23 5.45V21.55C23 23.459 18.3333 25 12.5 25C6.66667 25 2 23.459 2 21.55V5.45M23 13.5C23 15.409 18.3333 16.95 12.5 16.95C6.66667 16.95 2 15.409 2 13.5",
    stroke: "#464555",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtilities);
export default __webpack_public_path__ + "static/media/utilities.88db37e53da685dc29cec4d053e0c28f.svg";
export { ForwardRef as ReactComponent };